import { render, staticRenderFns } from "./UserGroupBarChart.vue?vue&type=template&id=e30899f0&"
import script from "./UserGroupBarChart.vue?vue&type=script&lang=js&"
export * from "./UserGroupBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports